import { apiClient } from './apiClient';

const getAdminCurrencies = async (data) => {
  return await apiClient.get('/dashboard/currencies', data);
};

const createAdminCurrency = async (data) => {
  return await apiClient.post_form('/dashboard/currencies', data);
};

const getAdminEditCurrency = async (id, data) => {
  return await apiClient.get(`/dashboard/currencies/edit/${id}`, data);
};

const updateAdminCurrency = async (id, data) => {
  return await apiClient.post_form(`/dashboard/currencies/${id}`, data);
};

const getCurrenciesValidator = async (data) => {
  return await apiClient.get('/api/currencies/validator', data);
};

const getCurrenciesLabel = async (data) => {
  return await apiClient.get('/api/currencies/label', data);
};

const getCurrencyPayments = async (data) => {
  return await apiClient.get('/api/currencies/payments', data);
};

const getCurrencyPaymentsType = async (data) => {
  return await apiClient.get('/api/currencies/payments_type', data);
};

export const adminCurrencyApi = {
  getAdminCurrencies,
  createAdminCurrency,
  getAdminEditCurrency,
  updateAdminCurrency,
  getCurrenciesValidator,
  getCurrenciesLabel,
  getCurrencyPayments,
  getCurrencyPaymentsType,
};
